import api from '@/api';
import apiV2 from '@/api/v2';
export const PLACES_API_PATH = 'places';
export const getPlacesList = async (params) => {
    const { data } = await api.get('places', { params });
    return data;
};
export const getSinglePlace = async (placeId) => {
    const { data } = await api.get(`places/${placeId}`);
    return data;
};
export const setPlaceCentralCostBudget = async (placeId, centralCost, payload) => await apiV2.post(`places/${placeId}/central-cost/${centralCost}/budget`, payload);
